<template>
    <div v-if="hasExtra">
        <hr class="mt-1 mb-3" :title="$t('campos-extras')" />

        <div class="columns is-flex-wrap">
            <div class="column is-6" v-for="conf in configextra" :key="conf.idconfigextra">
                <!-- Caso seja um campo de texto -->
                <v-input
                    v-if="started && conf.tipo == 'E'"
                    :id="conf.coluna + '-' + conf.idconfigextra"
                    :ref="conf.coluna + 'Input'"
                    v-model="innerExtra[conf.coluna].value"
                    @onBlurFunction="sendToDebounce(conf.coluna)"
                    placeholder="placeholder-preencha"
                    :validchars="conf.validchars"
                    :maxlength="20"
                    :title="conf.label"
                    :disableMLtitle="true"
                    :required="checkRequired(conf.coluna) && isRequired"
                    :invalid="checkInvalid(conf.coluna)"
                    :msg="innerExtra[conf.coluna].msg"
                    :disabled="cantEdit || !conf.pdadetalhe.altera"
                />
                <!-- Caso seja um campo de textarea -->
                <v-textarea
                    v-else-if="started && conf.tipo == 'M'"
                    :id="conf.coluna + '-' + conf.idconfigextra"
                    :ref="conf.coluna + 'Input'"
                    v-model="innerExtra[conf.coluna].value"
                    @onBlurFunction="sendToDebounce(conf.coluna)"
                    :title="conf.label"
                    :disableMLtitle="true"
                    :maxlength="1000"
                    placeholder="placeholder-preencha"
                    :validchars="conf.validchars"
                    :rows="4"
                    :maxRows="4"
                    :disableTransform="true"
                    :required="checkRequired(conf.coluna) && isRequired"
                    :invalid="checkInvalid(conf.coluna)"
                    :msg="innerExtra[conf.coluna].msg"
                    :disabled="cantEdit || !conf.pdadetalhe.altera"
                />
                <!-- Caso seja um campo de data -->
                <verified-date-picker
                    v-else-if="started && conf.tipo == 'D'"
                    :id="conf.coluna + '-' + conf.idconfigextra"
                    :ref="conf.coluna + 'Input'"
                    :infoIsHidden="false"
                    v-model="innerExtra[conf.coluna].value"
                    :title="conf.label"
                    :disableMLtitle="true"
                    placeholder="selecione-uma-data"
                    :subtractDateYears="80"
                    :addDateYears="5"
                    @onBlurFunction="sendToDebounce(conf.coluna)"
                    :yearsRange="[-50, 50]"
                    :inForm="true"
                    :required="checkRequired(conf.coluna) && isRequired"
                    :invalid="checkInvalid(conf.coluna)"
                    :msg="innerExtra[conf.coluna].msg"
                    :disabled="cantEdit || !conf.pdadetalhe.altera"
                />
                <!-- Caso seja um campo de select -->
                <!-- label="name" -->
                <vss-select
                    v-else-if="started"
                    :id="conf.coluna + '-' + conf.idconfigextra"
                    :ref="conf.coluna + 'Input'"
                    v-model="innerExtra[conf.coluna].value"
                    @onBlurFunction="sendToDebounce(conf.coluna)"
                    placeholder="selecione"
                    :title="conf.label"
                    :disableMLtitle="true"
                    :options="convertToJson(conf.tipo)"
                    :required="checkRequired(conf.coluna) && isRequired"
                    :invalid="checkInvalid(conf.coluna)"
                    :msg="innerExtra[conf.coluna].msg"
                    :disabled="cantEdit || !conf.pdadetalhe.altera"
                />
                <!-- <small>{{ innerExtra[`${conf.coluna}`] }}</small> -->
            </div>
        </div>
    </div>
</template>

<script>
/*
Ao chamar este componente deve verificar se é insert ou update
Exemplo prático em vendas/cliente/abas/dados-cadastrais/Geral.vue

<VerifiedConfigExtra 
    v-if="showConfigExtra"
    tabela="cliente"
    :extra="extra"
    :cantEdit="cantEdit"
    :isUpdate="isUpdate"
    :checkValidations="checkValidations"
    @validating="checkValidations=$event"
    @onChange="changeValConfigExtra($event)"
    aba="geral"
/>

Em created() { this.showConfigExtra = !this.isUpdate; }

Em methods: {
    changeValConfigExtra(tempExtra){
        Object.entries(tempExtra).forEach(([key, value]) => {
            this.extra[key] = value;
        });
    },
    setExtras() {
        this.extra.extra1.value = (!this.isNull(this.cliente.extra1))? 
            this.cliente.extra1 : null;
        this.extra.extra2.value = (!this.isNull(this.cliente.extra2))? 
            this.cliente.extra2 : null;
        this.extra.extra3.value = (!this.isNull(this.cliente.extra3))? 
            this.cliente.extra3 : null;

        setInterval(() => { this.showConfigExtra = true; }, 300);
    },
    saveValidations() {
        // inicia validação dos campos extras
        this.checkValidations = true;

        setTimeout(() => { 
            Object.entries(this.extra).forEach(([key, value]) => {
                if(!value.validated) invalid = true;
            });
        .........

}
*/

import ConfigExtraService from '@/services/ConfigExtraService';

export default {
    props: {
        // tabela do banco de dados
        tabela: {
            type: String,
            default: '',
        },
        // local do formuário que deve aparecer, sem valor mostra todos os extras
        aba: {
            type: String,
            default: '',
        },
        // libera ou não a edição
        cantEdit: {
            type: Boolean,
            default: false,
        },
        // se verdadeiro (ou omitido), pega obrigatoriedade da moduloPDA. Se falso, força componente a ser não-obrigatório
        isRequired: {
            type: Boolean,
            default: true,
        },
        // é insert ou update
        isUpdate: {
            type: Boolean,
            default: false,
        },
        // verificar preenchimento dos campos
        checkValidations: {
            type: Boolean,
            default: false,
        },
        /* dados que vem do componente pai, ex:
        extra: {
            extra1: {
                value: null, 
                obgInc: false,
                obgAlt: false,
                validated: true,
                msg: null,
            },
            extra2: ...
        }
        */
        extra: {
            type: Object,
            default: (_) => {},
        },
    },
    data() {
        return {
            service: new ConfigExtraService(this.$http, this.$router),
            // Array completo
            configextra: [],
            // dados internos
            innerExtra: {},
            // para verificar
            toCompareExtra: {},
            // guarda função debounce
            debouncedOnChange: null,
            // tempo para processar dados iniciais
            started: false,
            // passa função do útil para o componente

            // guarda temporariamente a coluna sendo alterada
            tempColuna: null,
            // confirma se existe um campo a ser mostrado
            hasExtra: false,
        };
    },
    created() {
        this.debouncedOnChange = this.debounce(this.onChange, 500);
        // Pega os valores caso seja edição
        // É utilizado JSON.parse e JSON.stringify para perder a referência
        this.innerExtra = JSON.parse(JSON.stringify(this.extra));
        this.toCompareExtra = JSON.parse(JSON.stringify(this.extra));
        // inicia busca no server
        this.carregarDados();
    },
    watch: {
        // quando mudar para true faz a validação
        checkValidations(val) {
            if (val) this.runValidations();
        },
    },
    methods: {
        convertToJson(tipo) {
            let options = JSON.parse(tipo).options;
            return options.map((m) => {
                return {
                    id: m.value,
                    label: m.name,
                };
            });
        },
        checkRequired(coluna) {
            return (
                this.innerExtra[coluna].obgInc || (this.isUpdate && this.innerExtra[coluna].obgAlt)
            );
        },
        checkInvalid(coluna) {
            return (
                (this.innerExtra[coluna].obgInc && this.isNull(this.innerExtra[coluna].value)) ||
                (this.isUpdate && !this.innerExtra[coluna].validated)
            );
        },
        sendToDebounce(coluna) {
            this.tempColuna = coluna;
            this.debouncedOnChange();
        },
        runValidations() {
            // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
            this.onChange();
            // avisa o componente pai que acabou a validação
            setTimeout(() => {
                this.$emit('validating', false);
            }, 300);
        },
        validate(coluna) {
            // Faz o focusAuto para aparecer o campo em vermelho caso inválido
            this.$refs[coluna + 'Input'][0].focusedOut = true;

            if (this.innerExtra[coluna].obgInc && this.isNull(this.innerExtra[coluna].value)) {
                // caso seja obrigatório inclusão
                this.innerExtra[coluna].msg = 'msg-campo-obrigatorio';
                this.innerExtra[coluna].validated = false;
                return this.innerExtra[coluna].validated;
            } else if (this.isUpdate && this.innerExtra[coluna].obgAlt) {
                // se form update e obriga alteração entra na validação
                let oldValue = this.isUpdate && this.toCompareExtra[coluna].value;
                oldValue =
                    !this.isNull(oldValue) ||
                    (!this.isNull(oldValue) && !this.onlyNumbers(oldValue))
                        ? oldValue.toString().toUpperCase()
                        : oldValue;
                let newValue = this.extra[coluna].value;
                newValue =
                    !this.isNull(newValue) ||
                    (!this.isNull(newValue) && !this.onlyNumbers(newValue))
                        ? newValue.toString().toUpperCase()
                        : newValue;

                // muda mensagem conforme tipo de validação
                if (oldValue == newValue) {
                    this.innerExtra[coluna].msg = 'msg-obriga-alteracao';
                    this.innerExtra[coluna].validated = false;
                } else {
                    this.innerExtra[coluna].msg = 'msg-campo-obrigatorio';
                    this.innerExtra[coluna].validated = true;
                }
                return this.innerExtra[coluna].validated;
            } else {
                this.innerExtra[coluna].validated = true;
                return this.innerExtra[coluna].validated;
            }
        },
        onChange() {
            // cria objetos temporários
            let tempInnerExtra = JSON.parse(JSON.stringify(this.innerExtra));

            // passa somente os valores dos campos que estão na config extra os dados
            if (this.tempColuna == null) {
                this.configextra.forEach((d) => {
                    // faz validação caso venha do runValidations
                    let tempValidate = this.validate(d.coluna);
                    tempInnerExtra[d.coluna].validated = tempValidate;
                });
            } else {
                // faz validação caso seja um change de um campo
                let tempValidate = this.validate(this.tempColuna);
                tempInnerExtra[this.tempColuna].validated = tempValidate;
            }

            // verifica se o campo é tipo data, então faz as ações necessárias
            this.configextra
                .filter((f) => f.tipo == 'D')
                .forEach((e) => {
                    if (!this.isNull(tempInnerExtra[e.coluna].value)) {
                        tempInnerExtra[e.coluna].value = this.$moment(
                            tempInnerExtra[e.coluna].value
                        ).format('DD/MM/YYYY');
                    }
                });
            // verifica se o campo é tipo select, então faz as ações necessárias
            this.configextra
                .filter((f) => f.tipo != 'D' && f.tipo != 'E' && f.tipo != 'M')
                .forEach((e) => {
                    if (!this.isNull(tempInnerExtra[e.coluna].value)) {
                        // está certo dois .value :)
                        tempInnerExtra[e.coluna].value = tempInnerExtra[e.coluna].value.id;
                    }
                });

            // envia os dados para o componente pai
            setTimeout(() => {
                this.tempColuna = null;
                this.$emit('onChange', tempInnerExtra);
            }, 500);
        },
        carregarDados() {
            this.service
                .findAllByTabela(this.tabela, this.aba)
                .then((value) => {
                    // faz a junção dos dados dos arrays por nome do campo
                    this.justaArrays(value.content);
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        justaArrays(value) {
            let filterExtra = {};
            // Verifica se existe algum campo na modulopdadetalhe
            let extras = ['extra1', 'extra2', 'extra3', 'extra4', 'extra5'];
            this.getModulo(this.tabela.toUpperCase()).detalhe.forEach((d) => {
                // verifica se contem um dos campos extras
                if (extras.includes(d.campo.toLowerCase()) && !d.oculta) {
                    // filtra a config extra do menmo campo extra
                    let temp = value.filter((f) => {
                        return f.coluna == d.campo.toLowerCase();
                    })[0];
                    // caso exista é adicionado ao array
                    if (!this.isNull(temp)) {
                        // guarda coluna em lower case para melhor utilização
                        let tempColuna = temp.coluna.toLowerCase();
                        // armazena dados de obrigações
                        this.innerExtra[tempColuna].obgInc = d.obrigainclusao;
                        this.innerExtra[tempColuna].obgAlt = d.obrigaalteracao;
                        this.innerExtra[tempColuna].msg = 'msg-campo-obrigatorio';
                        // Pega o valor padrão se não for update
                        if (!this.isUpdate) {
                            this.innerExtra[tempColuna].value = this.isNull(d.valorpadrao)
                                ? null
                                : d.valorpadrao;
                        }
                        // Verifica se o campo é do tipo data e se veio valor inicial
                        if (temp.tipo == 'D' && !this.isNull(this.innerExtra[tempColuna].value)) {
                            if (
                                this.$moment(this.innerExtra[tempColuna].value, [
                                    'DD/MM/YYYY',
                                    'YYYY-MM-DD',
                                ]).isValid()
                            ) {
                                this.innerExtra[tempColuna].value = this.$moment(
                                    this.innerExtra[tempColuna].value,
                                    ['DD/MM/YYYY', 'YYYY-MM-DD']
                                ).toDate();
                            } else {
                                this.innerExtra[tempColuna].value = null;
                            }
                        }
                        // Verifica se o campo é do tipo select e filtra o objeto para inicialização com valores corretos
                        if (
                            temp.tipo != 'D' &&
                            temp.tipo != 'E' &&
                            temp.tipo != 'M' &&
                            !this.isNull(this.innerExtra[tempColuna].value)
                        ) {
                            this.innerExtra[tempColuna].value = Object.assign(
                                {},
                                this.convertToJson(temp.tipo).filter((f) => {
                                    return (
                                        f.id.toUpperCase() ==
                                        this.innerExtra[tempColuna].value.toUpperCase()
                                    );
                                })[0]
                            );
                        }
                        filterExtra[tempColuna] = this.innerExtra[tempColuna];
                        // vincula o pdadetalhe ao configextra
                        temp.pdadetalhe = Object.assign({}, d);
                        this.configextra.push(temp);
                    }
                }
            });
            setTimeout(() => {
                this.innerExtra = Object.assign({}, filterExtra);

                this.started = true;

                let found = Object.keys(this.innerExtra).filter((key) => key);
                this.hasExtra = found.length > 0;
                this.$emit('hasExtra', this.hasExtra);

                // carrega uma vez para guardar na memória
                this.debouncedOnChange();
            }, 400);
        },
    },
};
</script>
